'use strict';
import React, { PureComponent } from 'react';
import { createForm } from 'rc-form';
import Formulario from './Formulario/Formulario'
import Footer from './Footer';
import { Redirect } from 'react-router-dom';
import { GenericModal, GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';


class EditarConfiguracionProceso extends PureComponent {
    constructor(props) {
        super(props);
    }


    componentDidMount() {
        this.props.resetState();
        const id = this.props.match.params.id;
        this.props.getScreenData(id, this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {
        const { data, selectRadio, changeInput, setCheck, seleccionarCombo,
            cancelProcess, validateAddProcess, finishProcess, checkArchivosAsociados, setNombreArchivo
            ,setOptionFormatoArchivo, setRadioButton } = this.props;
        let { isLoading } = false;

        let componente = <div className="loading">Loading &#8230;</div>;


        if (data.redirect.shouldRedirect)
            return <Redirect to={data.redirect.to} push />;

        if (!isLoading) {
            
            componente = <div className="container">
                <div className="container-fluid row">

                    <Formulario data={data}
                        selectRadio={selectRadio}
                        changeInput={changeInput}
                        setCheck={setCheck}
                        seleccionarCombo={seleccionarCombo}
                        checkArchivosAsociados={checkArchivosAsociados}
                        setNombreArchivo={setNombreArchivo}
                        setOptionFormatoArchivo={setOptionFormatoArchivo}
                        setRadioButton={setRadioButton}
                        
                    />
                    <Footer data={data}
                        cancelProcess={cancelProcess}
                        validateAddProcess={validateAddProcess}
                    />

                    <GenericModal type={"OK_OTHER"} className="modal fade-out" id={"error"}
                        header={"La transacción no puede ser procesada"}
                        body={"Por favor comuniquese con Soporte técnico para recibir asistencia y solucionarlo lo antes posible. Su número de transacción es " + this.props.data.sagaId}
                        onClick={finishProcess} />
                    <GenericModal type={"OK_OTHER"} className="modal fade-out" id={"completada"}
                        body={"La transacción ha sido modificada exitosamente."}
                        onClick={finishProcess} />
                    <GenericModal type={"OK_OTHER"} className="modal fade-out" id={"completadaConDependencias"}
                        header={"La transacción esta pendiente a ser procesada"}
                        body={"Disculpe, hay datos en la transacción que dependen de procesos que todavían no fueron finalizados, por lo que aun no se encuentra confirmada.\nUsted no debe hacer nada: Una vez que los procesos de los que dependen esta transacción hayan finalizado correctamente será avisado y la transacción avanzará automáticamente por su circuito normal."}
                        onClick={finishProcess} />

                </div>

            </div>
        }
        return (

            <div>
                {componente}

            </div>);
    }
}

export default createForm()(EditarConfiguracionProceso);